exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vuecheckbox, a.vuecheckbox {\n    font-size: 22px;\n    height: 45px;\n    width: 45px;\n    flex: 0 0 45px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    user-select: none;\n    outline: 0;\n}\na.vuecheckbox:hover, a.vuecheckbox:active, a.vuecheckbox:focus {\n    text-decoration: none;\n}\n.loading { opacity: 0.75\n}\n.green { color: #1b8a1b;\n}\n.amber { color: #e09100;\n}\n", ""]);

// exports
